import { Component, Input, OnInit } from "@angular/core";
import {
  getErrorMessage,
  handleValidationErrorMessage,
  isFormValid,
} from "../../../../utilities/utils";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { dateNotInFuture, invalidDate } from "../../../../utilities/validators";
import { employeeFinanceDataErrors } from "../employee-finance-data.errors";
import { NbDialogRef, NbToastrService } from "@nebular/theme";
import { EmployessService } from "../../../../shared/employess/employess.service";
import { EmployeeFinanceDataPayload } from "../employee-finance-data.model";

@Component({
  selector: "employee-finance-data-dialog",
  templateUrl: "./employee-finance-data-dialog.component.html",
  styleUrls: ["./employee-finance-data-dialog.component.scss"],
})
export class EmployeeFinanceDataDialogComponent implements OnInit {
  @Input() title: string;
  @Input() employeeUid: string;
  @Input() type: "amount-owing" | "repayment";

  public form: FormGroup;
  public utils = {
    handleValidationErrorMessage,
    isFormValid,
  };
  public errorMessages = employeeFinanceDataErrors;
  public isLoading = false;

  constructor(
    protected ref: NbDialogRef<EmployeeFinanceDataDialogComponent>,
    private employeeService: EmployessService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.form = new FormGroup({
      moneyDate: new FormControl(new Date().toISOString(), [
        Validators.required,
        invalidDate,
        dateNotInFuture,
      ]),
      moneyValue: new FormControl(null, [Validators.required]),
      moneyExpiryDate: new FormControl(null, [invalidDate]),
      description: new FormControl(null, [Validators.required]),
    });

    this.form.get("moneyValue")!.valueChanges.subscribe((value) => {
      if (value === null || value === "" || value === undefined) return;

      const num = Number(value);

      if (isNaN(num)) return;

      if (num <= 0) {
        this.form.get("moneyValue")!.setValue(0.01, { emitEvent: false });
      }
    });
  }

  clearMoneyExpiryDate() {
    this.form.patchValue({ moneyExpiryDate: null });
  }

  saveData() {
    this.isLoading = true;

    let moneyValue = this.form.get("moneyValue").value;

    if (this.type === "repayment") {
      moneyValue = -Math.abs(moneyValue);
    }

    const payload: EmployeeFinanceDataPayload = {
      moneyDate: this.form.get("moneyDate").value,
      moneyValue,
      moneyExpiryDate: this.form.get("moneyExpiryDate").value,
      description: this.form.get("description").value,
    };

    this.employeeService
      .addEmployeeFinanceDataItem(this.employeeUid, payload)
      .subscribe({
        next: () => {
          let message;

          if (this.type === "amount-owing") {
            message = "Amount owing added successfully";
          } else if (this.type === "repayment") {
            message = "Repayment added successfully";
          }

          this.toastrService.success(message, "Success");
          this.ref.close(true);
        },
        error: (err) => {
          this.isLoading = false;
          this.toastrService.danger(getErrorMessage(err), "Error", {
            duration: 60000,
            destroyByClick: true,
          });
        },
      });
  }

  closeWindow() {
    this.ref.close(false);
  }
}
